import { createApiCallActions } from '../../../../common/store/generic.actions';
import { KnownIpAddressModel } from './types';

export const knownIpAddressActions = {
  getById: createApiCallActions<KnownIpAddressModel>(
    'knownIpAddress',
    'getById',
  ),
  update: createApiCallActions<KnownIpAddressModel>(
    'knownIpAddress',
    'update',
  ),
};

export type KnownIpAddressAction = typeof knownIpAddressActions;
